
import './App.css';
import Navbar from './components/Navbar';
 import TextForm from './components/TextForm';
 import About from './components/About';

import { useState } from 'react';
import Alert from './components/Alert';
import React from 'react';
import{
  BrowserRouter as Router,
  Route,
  Switch,
  
}from "react-router-dom";


function App() {
  const [mode,setmode] = useState('light')
  const [alert,setalert] = useState(null);

  const ShowAlert = (message,type) =>{
    setalert({
      msg:message,
      type:type
    })
    setTimeout(()=>{
      setalert(null)
    },2000);



  }
  function removebody(){
    document.body.classList.remove('bg-light')
    document.body.classList.remove('bg-dark')
    document.body.classList.remove('bg-warning')
    document.body.classList.remove('bg-success')
    document.body.classList.remove('bg-danger')
    document.body.classList.remove('bg-primary')
  }
  const toggleMode = (cls) =>{
    removebody();
    document.body.classList.add('bg-'+cls)
    if(mode === 'light'){
      setmode('dark')
      document.body.style.backgroundColor = "grey";
      document.body.style.color = "white";
      ShowAlert(`${cls} mode has been enable`,'success');
    }else{
      setmode('light')
      document.body.style.backgroundColor = "white";
      document.body.style.color = "black";
      ShowAlert(`${cls} mode has been enable`,'success');
    }

  }

  return (
   <>


 <Router> 
<Navbar title="TextUtils"  mode={mode} toggleMode={toggleMode} />
<Alert alert={alert} />

<div className="container my-3">
<Switch>
    <Route exact path="/about" >
    <About mode={mode} />
      
    </Route>
    <Route exact path="/">
    <TextForm heading = "Enter the text to analyze below" ShowAlert={ShowAlert} />
    
    </Route>
  </Switch>


</div>

</Router> 
   </>
  );
}

export default App;


